<template>
  <v-layout row wrap class="px-2">
    <v-flex>
      <v-app-bar
        app
        long
        color="primary"
        class="header-bar"
        src="@/assets/images/Header-Background-top_.png"
      >
        <v-btn text class="pa-0" :to="{ name: 'dashboard' }">
          <img
            src="@/assets/images/logo.png"
            width="100"
            alt="Logo NAV"
            class="ml-10 ma-auto"
          />
        </v-btn>
        <v-flex xs4 class="pa-0">
          <v-toolbar-title class="white--text pl-5">
            <v-layout row wrap>
              <span class="subtitle-1"> Help Center </span>
            </v-layout>
          </v-toolbar-title>
        </v-flex>
        <v-spacer></v-spacer>
        <a class="white--text body-2 px-3"> Download </a>
        <a class="white--text body-2 px-3"> Release Notes </a>
        <router-link
          :to="{ name: 'help-center-faq' }"
          class="white--text body-2 pl-3 pr-10"
          style="text-decoration: none"
        >
          FAQ
        </router-link>
      </v-app-bar>
      <v-main>
        <!-- Page Header -->
        <div
          class="page-wrapper white"
          style="min-height: 85vh;padding-left; 28px !important"
        >
          <router-view></router-view>
        </div>
        <!-- App Footer -->
        <v-footer height="auto" class="white pa-3 app--footer text--center">
          <span class="caption pl-4 primary--text">
            GITS Indonesia &copy; {{ new Date().getFullYear() }}
          </span>
          <v-spacer></v-spacer>
        </v-footer>
      </v-main>
    </v-flex>

    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </v-layout>
</template>

<script>
import ProgressDialog from '../progress_dialog';
import ACLMixin from '../../mixins/ACLMixin';
import Swal from 'sweetalert2';

export default {
  mixins: [ACLMixin],
  props: {
    source: String
  },
  components: {
    'progress-dialog': ProgressDialog
  },
  data: () => ({
    dialog: false,
    progressDialogLoading: false,
    showDialog: false,
    show: false,
    show1: false,
    show2: false,
    modalChangePassword: false,
    new_password: '',
    current_password: '',
    confirm_password: '',
    disabledItems: '',
    title: 'Dashboard',
    user: localStorage.getItem('name'),
    email: localStorage.getItem('username'),
    desc: JSON.parse(localStorage.getItem('userProfile')),
    profileItems: JSON.parse(localStorage.getItem('profileList')),
    drawer: true,
    profileId: null,
    timeout: null,
    scrollSettings: {
      maxScrollbarLength: 160
    },
    width: 0,
    miniToolbar: false
  }),
  mounted() {
    this.profileItem();
  },
  computed: {
    computedItems() {
      return this.profileItems.map(item => {
        return {
          id: item.id,
          text: item.desc,
          disabled: this.disabledItems.toString().includes(item.id)
        };
      });
    }
  },
  methods: {
    handleDrawer() {
      if (this.$vuetify.breakpoint.mdAndDown) {
        this.drawer = !this.drawer;
      } else {
        this.miniToolbar = !this.miniToolbar;
      }
    },
    profileItem() {
      for (let i = 0; i < this.profileItems.length; i++) {
        if (this.profileItems[i].id == localStorage.getItem('profile_id')) {
          this.disabledItems = this.profileItems[i].id;
        }
      }
    },
    isWidth() {
      if (this.$vuetify.breakpoint.width < 1264) {
        return 'width-mdDown';
      } else {
        return 'width-mdUp';
      }
    },
    async logout() {
      await this.$store.dispatch('auth/logout');
      localStorage.clear();
      this.$router.push({
        name: 'login'
      });
    },
    getIcon(pict) {
      return require('@/assets/images/navbar/' + pict + '.png');
    },
    submit() {
      this.progressDialogLoading = true;
      this.showDialog = false;
      if (this.profileId) {
        const params = {
          profile_id: this.profileId.id
        };
        this.$store
          .dispatch('auth/getRoleConfig', params)
          .then(data => {
            if (data.code === 200) {
              localStorage.setItem(
                'userRole',
                JSON.stringify(data.data.mapping)
              );
              localStorage.setItem('userProfile', JSON.stringify(data.data));
              localStorage.setItem(
                'profile_id',
                JSON.stringify(this.profileId.id)
              );
              this.desc = JSON.parse(localStorage.getItem('userProfile'));
              this.profileId = {};
              this.profileItem();
              if (this.$router.currentRoute.name === 'dashboard') {
                this.$router.go({ name: 'dashboard' });
              } else {
                this.$router.push({ name: 'dashboard' });
                this.progressDialogLoading = false;
              }
            } else {
              Swal.fire('Failed!', data.response.data.data.error, 'error');
            }
          })
          .catch(err => {
            Swal.fire('Failed!', err.response.data.data.text_en, 'error');
          });
      } else {
        this.showDialog = false;
      }
    }
  }
};
</script>
<style>
.v-navigation-drawer__content {
  overflow: hidden !important;
}
.drawer-menu--scroll__ {
  height: 470px;
  overflow: auto;
}
.title-page {
  font-weight: bold;
  font-size: 22px;
  line-height: 29px;
}
.v-toolbar__content,
.v-toolbar__extension {
  padding-left: 0px !important;
}
.v-application--is-ltr
  .v-list-group--no-action
  > .v-list-group__items
  > div
  > .v-list-item {
  padding-left: 53px !important;
}
/* .v-navigation-drawer {
  width: 266px !important;
} */
.v-list-group
  .v-list-group__header
  .v-list-item__icon.v-list-group__header__append-icon {
  min-width: 13px !important;
}
/* .v-toolbar {
  left: 266px !important;
}
.v-content {
  padding: 64px 0px 0px 266px !important;
} */
#mainMenu .v-list-item {
  min-height: 40px !important;
}

.header-bar {
  box-shadow: none !important;
}
</style>
